import { getData, postData, patchData, deleteData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';
import cacheManager from 'src/utils/cache';

export const getBodyParts = async () => {
  const url = `${urlMap.concerns.bodyParts}`;
  return getData(url);
};

export const getConcerns = async (bodyPart) => {
  const url = `${urlMap.treatments.procedures.replace('{body_part}', bodyPart)}`;
  return getData(url);
};


export const getConcernId = async (bodyPart, procedure, concern) => {
  const url = `${urlMap.treatments.treatmentId // Keeping urlMap.treatments for URL construction
    .replace('{body_part}', bodyPart)
    .replace('{procedure}', procedure)
    .replace('{concern}', concern)}`;
  return getData(url);
};



export const getAllConcerns = async (pageValue = 1, limitValue = 10) => {
  const url = `${urlMap.concerns.all
    .replace('pageValue', `${pageValue}`)
    .replace('limitValue', `${limitValue}`)}`;
  return getData(url);
};


export const getSelectOptions = async () => {
  const data = `${urlMap.treatments.data}` // Keeping urlMap.treatments for URL construction
  return getData(data);
}

export const createConcern = async (data) => {
  const url = `${urlMap.concerns.create}`;
  const result = await postData(url, data);
  
  // Invalidate concern lists and related treatments/packages
  cacheManager.invalidateResource('concerns');
  cacheManager.invalidate('/v1/treatments');
  cacheManager.invalidate('/v1/packages');
  
  return result;
}

export const updateConcern = async (concernId, data) => {
  console.log(concernId);
  const url = `${urlMap.concerns.update.replace('{concernId}', concernId)}`;
  const result = await patchData(url, data);
  
  // Explicitly invalidate concern cache and related resources
  cacheManager.invalidateResource('concerns', concernId);
  cacheManager.invalidate('/v1/concerns');
  
  // Invalidate treatments and packages that might reference this concern
  cacheManager.invalidate('/v1/treatments');
  cacheManager.invalidate('/v1/packages');
  
  return result;
}

export const deleteConcern = async (concernId) => {
  console.log(concernId);
  const url = `${urlMap.concerns.delete.replace('{concernId}', concernId)}`;
  const result = await deleteData(url);
  
  // Invalidate concern cache and related resources
  cacheManager.invalidateResource('concerns', concernId);
  cacheManager.invalidate('/v1/treatments');
  cacheManager.invalidate('/v1/packages');
  
  return result;
}
export const searchConcerns = async (name) => {
  const url = `${urlMap.concerns.search.replace('{name}', name)}`;
  return getData(url);
};
